import useReactHookForm from "hooks/useReactHookForm";
import {
  createStdCourseInitialValues,
  createStdCourseMandatoryFields,
  searchStdCourseMandatoryFields,
  createStdCourseValidationSchema,
  CourseProperties,
  table,
  createStdCoursePropertiesFirst,
  createStdCoursePropertiesSecond,
  tableCreate,
  isCourseIdInMetadata,
} from "./helper";
import { Button, Grid, Paper, Typography } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { useEffect, useState } from "react";
import {
  getBatchFromClassId,
  getBatchFromClassIdReturn,
  getCollegeFromStateId,
  getCourseFromClassId,
  getCourseFromClassIdReturn,
} from "utils/metadata-split/depedentApiFetch";
import configueService from "pages/configue/service";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import { areArraysEqual, getValuesByIds, META_FIELD_MAP, PC_METADATA_KEYS, removeDuplicates, setReactFormValues } from "pages/configue/constants";
import {
  emptyCourseData,
  StudentCourseLookupRequest,
  UpdateSingleStdCourseDetails,
} from "pages/configue/slices/student-course-slice";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { isEmpty } from "utils/helpers";
import Loader from "pages/build-test/loader";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import NoDataFound from "shared/molecules/no-data";
import LoadingButton from "@mui/lab/LoadingButton";

export const CreateStdCourse = () => {
  const [triggerSetValue, setTriggerSetValue] = useState(false);
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    createStdCourseInitialValues,
    createStdCourseValidationSchema,
    ""
  );
  const [courseDetails, setCourseDetails] = useState<any>([]);
  const [isEnabled, setisEnabled] = useState(false);
  const [showSecondaryFields, setShowSecondaryFields] = useState(false);
  const [btnLoading,setBtnLoading]=useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const [course, setCourse] = useState<any>([]);
  const { data, error, loading } = useAppSelector(
    (state) => state.studentCourseLookup
  );

  const updateMetaData = async (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    await dispatch(metadataSuccess(metadataList));
    if (metaKey == "batch_list" && listData?.length == 0) {
      setValue("batch_list", []);
    }
    if (metaKey == "college_list" && listData?.length == 0) {
      setValue("college_list", []);
    }
  };

  const takeRequiredValue = (classList, key) => {
    const classNameList = classList?.map((SingleClass) => {
      return SingleClass[`${key}`];
    });
    return classNameList;
  };

  const convertDataToTableData = () => {
    const tableData = data.map((item, i) => {
      let singleCourse = { ...item };

      singleCourse["class_list"] = getValuesByIds(
        item?.class_id_list,
        META_FIELD_MAP.CLASS_ID,
        META_FIELD_MAP.CLASS_NAME,
        PC_METADATA_KEYS.CLASS_LIST,
        metaData
      );
      singleCourse["course_list"] = getValuesByIds(
        item?.course_id,
        META_FIELD_MAP.COURSE_ID,
        META_FIELD_MAP.COURSE_NAME,
        PC_METADATA_KEYS.COURSE_LIST,
        metaData
      );
      singleCourse["year_list"] = getValuesByIds(
        item?.year_id_list,
        META_FIELD_MAP.ACADEMIC_YEAR_ID,
        META_FIELD_MAP.ACADEMIC_YEAR_NAME,
        PC_METADATA_KEYS.ACADEMIC_YEAR_LIST,
        metaData
      );
      singleCourse["state_list"] = getValuesByIds(
        item?.state_id_list,
        META_FIELD_MAP.STATE_ID,
        META_FIELD_MAP.STATE_NAME,
        PC_METADATA_KEYS.STATE_LIST,
        metaData
      );
      singleCourse["batch_list"] = getValuesByIds(
        item?.batch_id_list,
        META_FIELD_MAP.BATCH_ID,
        META_FIELD_MAP.BATCH_NAME,
        PC_METADATA_KEYS.BATCH_LIST,
        metaData
      );
      singleCourse["board_list"] = getValuesByIds(
        item?.board_id_list,
        META_FIELD_MAP.BOARD_ID,
        META_FIELD_MAP.BOARD_NAME,
        PC_METADATA_KEYS.BOARD_LIST,
        metaData
      );
      singleCourse["college_list"] = removeDuplicates(getValuesByIds(
        item?.college_id_list,
        META_FIELD_MAP.COLLEGE_ID,
        META_FIELD_MAP.COLLEGE_NAME,
        PC_METADATA_KEYS.COLLEGE_LIST,
        metaData
      ));
      singleCourse["registration_status_list"] = getValuesByIds(
        item?.registration_status_id_list,
        META_FIELD_MAP.REGISTRATION_STATUS_ID,
        META_FIELD_MAP.REGISTRATION_STATUS_NAME,
        PC_METADATA_KEYS.REGISTRATION_STATUS_LIST,
        metaData
      );
      return singleCourse;
    });
    setCourseDetails(tableData);
  };

  const convertUpdatedDataToTableData = (updateddata) => {
    const tableData = updateddata.map((item, i) => {
      let singleProgram = { ...item };
      singleProgram["class_list"] = takeRequiredValue(
        item?.class_list,
        "class_name"
      );
      singleProgram["program_id"] = takeRequiredValue(
        item?.program_list,
        "program_id"
      );
      singleProgram["program_name"] = takeRequiredValue(
        item?.program_list,
        "program_name"
      );
      return singleProgram;
    });
    setCourseDetails(tableData);
  };

  const handleCreateCourse = async () => {
    setBtnLoading(true);
    const reqBody = {
      id: "id",
      academic_year_list: watch()?.academic_year_list,
      registration_status_list: watch()?.reservation_status_list,
      class_list: watch()?.class_list,
      batch_list: watch()?.batch_list,
      state_list: watch()?.state_list,
      college_list: watch()?.college_list,
      board_list: watch()?.board_list,
      course_id: watch()?.course_id,
      is_secondary_course:
        watch()?.is_secondary_course == "true" ? true : false,
      is_default_course: watch()?.is_default_course == "true" ? true : false,
      is_early_bird_course:
        watch()?.is_early_bird_course == "true" ? true : false,
    };
    const res: any = await configueService.createCourseLookupApi(reqBody);
    if (res?.status === 200 && res?.data?.status === "success") {
      dispatch(snackbarRequest({ message: "created successfully" }));
      setBtnLoading(false);
      history.replace(`/configue/student_course_lookup`);
    } else {
      setBtnLoading(false);
      dispatch(snackbarRequest({ message: res.data.message, type: "error" }));
    }
  };

  const convertArrayToString = (arr) => {
    const params = {};
    let payloadString = "";
    if (typeof arr == "string") {
      return arr;
    } else if (arr?.length > 0) {
      arr.forEach((sateid, i) => {
        if (i == arr.length - 1) {
          payloadString = payloadString + sateid;
        } else {
          payloadString = payloadString + sateid + ",";
        }
      });
      return payloadString;
    }
  };

  const handleSearch = () => {
    setisEnabled(true);
    const payload = {
      class: convertArrayToString(watch()?.class_list),
      academic_year: convertArrayToString(watch()?.academic_year_list),
      registration_status: convertArrayToString(
        watch()?.reservation_status_list
      ),
      // batch_list: watch()?.batch_list,
      limit: 200,
      offset: 0,
      exact_match: true,
      boolean_operation: "AND",
    };
    dispatch(StudentCourseLookupRequest(payload));
  };
  const handleEdit = async (courseId) => {
    const res: any = await configueService.getSingleCourseLookup({
      lookup_id: courseId?.id,
    });
    if (res?.status === 200 && res?.data?.status === "success") {
      dispatch(UpdateSingleStdCourseDetails(res?.data?.data?.[0]));
      history.push(`/configue/student_course_lookup/edit/${courseId?.id}`);
    }
  };

  const handleSubmit = () => {
    const courseId = watch()?.cousre_id;
    if (courseId) {
      const updatedData = data.filter(
        (item) => item?.course_list?.course_id === courseId
      );
      convertUpdatedDataToTableData(updatedData);
    }
  };

  const updateMetaDataClassIdChange = async (listData, metaKey,listData2, metaKey2) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    await dispatch(metadataSuccess(metadataList));
    if (metaKey == "batch_list" && listData?.length == 0) {
      setValue("batch_list", []);
    }
    if (metaKey2 == "course_list_dep" && listData2?.length == 0) {
      setValue("course_id", "");
    }
  };

  useEffect(() => {
    setTimeout(async () => {
      await getCollegeFromStateId(watch()?.state_list, updateMetaData);
    }, 1000);
  }, [watch()?.state_list]);

  useEffect(() => {
    setTimeout(async() => {
     const call1= await getBatchFromClassIdReturn(watch()?.class_list, updateMetaData);
     const call2= await getCourseFromClassIdReturn(watch()?.class_list, updateMetaData);
     updateMetaDataClassIdChange(call1[0],call1[1],call2[0],call2[1])
    }, 1000);
  }, [watch()?.class_list]);

  useEffect(() => {
    if (metaData?.batch_list?.length > 0 && !isLoad && triggerSetValue) {
      let matchedVales = setReactFormValues(
        metaData,
        "batch_list",
        watch()?.batch_list,
        "batch_id"
      );
      let isEqual = areArraysEqual(watch()?.batch_list, matchedVales);
      if (!isEqual) {
        setValue("batch_list", matchedVales);
      }
    }
  }, [metaData?.batch_list, triggerSetValue]);

  useEffect(() => {
    if (metaData?.college_list?.length > 0 && !isLoad && triggerSetValue) {
      let matchedVales = setReactFormValues(
        metaData,
        "college_list",
        watch()?.college_list,
        "college_id"
      );
      let isEqual = areArraysEqual(watch()?.college_list, matchedVales);
      if (!isEqual) {
        setValue("college_list", matchedVales);
      }
    }
  }, [metaData?.college_list]);

  useEffect(() => {
    if (
      !isEmpty(metaData?.course_list_dep?.length) &&
      !isLoad &&
      triggerSetValue &&
      isEmpty(watch()?.course_id)
    ) {
      const isCourseIdinList = isCourseIdInMetadata(
        metaData?.course_list_dep,
        "course_id",
        watch()?.course_id
      );
      if (!isCourseIdinList) {
        setValue("course_id", "");
      }
    }
  }, [metaData?.course_list_dep]);

  useEffect(() => {
    setTimeout(() => {
      setTriggerSetValue(true);
    }, 3000);
  }, []);

  useEffect(() => {
    if (data.length > 0 && isEnabled) {
      convertDataToTableData();
    } else {
      setCourseDetails([]);
    }
  }, [data]);

  useEffect(() => {
    if (watch()?.is_secondary_course == "true") {
      setValue("is_default_course", "false");
      setValue("is_early_bird_course", "false");
    }
  }, [watch()?.is_secondary_course]);

  useEffect(() => {
    dispatch(emptyCourseData());
  }, []);

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Create New Course Mapping
        </Typography>
        <Grid container spacing={2}>
          <DynamicForm
            fields={createStdCoursePropertiesFirst}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>
        <ContentRight sx={{ mt: -7 }}>
          <Button
            variant="contained"
            sx={{
              width: "80px",
              height: "40px",
              marginTop: "15px",
              padding: "7px 42.5px 7px 48.5px",
              cursor: "pointer",
              textAlign: "center",
            }}
            onClick={handleSearch}
            disabled={
              !isFieldsValidate(
                errors,
                searchStdCourseMandatoryFields,
                getValues
              )
            }
          >
            Search
          </Button>
        </ContentRight>
        {/* use to get courses based on class_id */}
        {isEnabled && !showSecondaryFields && (
          <div style={{ marginTop: "15px" }}>
            <ContentRight sx={{ mt: -7 }}>
              <Button
                variant="contained"
                sx={{
                  width: "180px",
                  height: "40px",
                  marginTop: "55px",
                  padding: "7px 20px 7px 20px",
                  cursor: "pointer",
                  textAlign: "center",
                  marginBottom: "15px",
                }}
                onClick={() => {
                  setShowSecondaryFields(true);
                }}
                disabled={
                  !isFieldsValidate(
                    errors,
                    searchStdCourseMandatoryFields,
                    getValues
                  )
                }
              >
                Proceed to Create
              </Button>
            </ContentRight>
          </div>
        )}
        {showSecondaryFields && (
          <div style={{ marginTop: "15px" }}>
            <Grid container spacing={2}>
              <DynamicForm
                // fields={CourseProperties(watch())}
                fields={createStdCoursePropertiesSecond(watch())}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            </Grid>
            <ContentRight sx={{ mt: 0 }}>
              <LoadingButton
                variant="contained"
                loadingPosition="start"
                color="primary"
                onClick={handleCreateCourse}
                loading={btnLoading}
                style={{
                  width: "120px",
                  height: "40px",
                  marginTop: "15px",
                  padding: "7px 42.5px 7px 48.5px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                disabled={
                  !isFieldsValidate(
                    errors,
                    createStdCourseMandatoryFields,
                    getValues
                  )
                }
              >
                Create
              </LoadingButton>
            </ContentRight>
          </div>
        )}
        {loading && <Loader />}
        {!isEmpty(courseDetails) && (
          <CollapsibleTable
            data={courseDetails}
            table={tableCreate}
            id="id"
            handleEdit={handleEdit}
            rowsPerPageCount={10}
            paginationSegmentApi="false"
            hasPageApiCall={false}
          />
        )}

        {!loading && isEmpty(courseDetails) && isEnabled && (
          <div>
            <NoDataFound></NoDataFound>
          </div>
        )}
      </Paper>
    </div>
  );
};
